import axiosConfig from "./axiosConfig";

interface FileUploadUrl {
  url: string;
  fileGuid: string;
}

const getSiteFileUploadUrl = async (
  authToken: string,
  siteId: string,
  siteFileType: string,
  contentType: string,
  fileGuid?: string | null,
  fileName?: string
): Promise<FileUploadUrl> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/file`,
    {
      fileGuid: fileGuid ? fileGuid : undefined,
      fileName,
      contentType,
      siteFileType,
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteFileUploadUrl;
